import { createAction } from "redux-act";

export const REQTagList = createAction("REQUEST_TAG_LIST");
export const RESTagList = createAction("RECEIVE_TAG_LIST");
export const FailTagList = createAction("FAILED_TAG_LIST");
export const CleanUpTagList = createAction("CLEANUP_TAG_LIST");